import React from "react";
import { PageProps } from "gatsby";

import { AgeWarning } from "components/AgeWarning";
import { WarningContextProvider } from "hooks/useAgeWarningState";
import { DMMPopupContextProvider } from "hooks/useDMMPopupState";
import { useMetadata } from "hooks/useMetadata";
import { SoundWarningContextProvider } from "hooks/useSoundWarning";

export default function MyModal({
    children,
    pageContext,
}: PageProps<null, { layout: string; language: string }>) {
    const metadata = useMetadata();

    if (pageContext.layout === "no-layout") return <>{children}</>;

    return (
        <WarningContextProvider>
            <SoundWarningContextProvider>
                <DMMPopupContextProvider>
                    {children}
                    <AgeWarning />
                </DMMPopupContextProvider>
            </SoundWarningContextProvider>
        </WarningContextProvider>
    );
}
